// @mui material components
import {
  Snackbar,
  Alert,
  Grid,
  Card,
  CircularProgress,
  Backdrop,
  Icon,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  DialogActions,
  MenuItem,
  InputLabel,
  Select,
  FormControl,
} from "@mui/material";

// Material Dashboard 2 React components
import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
import MDInput from "theme/components/MDInput";
import MDButton from "theme/components/MDButton";

// Material Dashboard 2 React example components
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";

// import { useAuthUser, useAuthHeader } from "react-auth-kit";

import { useEffect, useState } from "react";
import axios from "axios.js";
import { useIsAuthenticated } from "react-auth-kit";
import { useNavigate } from "react-router-dom";
import usePageTitle from "app/pageTitle";
import CompanyNotification from "app/company_notification";

function BankAccounts() {
  const pageTitle = "Virtual Bank Accounts";
  usePageTitle(pageTitle);

  const isAuthenticated = useIsAuthenticated();
  if (!isAuthenticated()) {
    const navigate = useNavigate();
    navigate("/sign-in");
  }

  const [virtualAccounts, setVirtualBanks] = useState([]);
  const [currencies, setCurrencies] = useState([]);
  const [commercials, setCommercials] = useState(null);

  const [showCompanyNotification, setShowCompanyNotification] = useState(false);
  const [companyNotification, setCompanyNotification] = useState(null);

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };

  const [refreshPage, setRefreshPage] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get("users/vbank/ALL/list.json")
        .then((result) => {
          // console.log(result);
          setShowLoading(false);
          if (result.data.status === "success") {
            setVirtualBanks(result.data.data.virtual_accounts);
            setCurrencies(result.data.data.currencies);
            setCommercials(result.data.data.commercials);

            if (result.data.notification) {
              setCompanyNotification(result.data.notification);
              if (result.data.notification.pages.includes("ALL")) {
                setShowCompanyNotification(true);
              } else if (result.data.notification.pages.includes("vbanks")) {
                setShowCompanyNotification(true);
              }
            }
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg("An error occurred.");
          setOpen(true);
        });
    };

    fetchData();
  }, [refreshPage]);

  let formData;

  const [currency, setCurrency] = useState(null);
  const [openVBankDialog, setOpenVBankDialog] = useState(false);
  const [openNewBankDialog, setOpenNewBankDialog] = useState(false);
  const [addressHouseNumber, setAddressHouseNumber] = useState(null);
  const [addressStreet, setAddressStreet] = useState(null);
  const [addressCity, setAddressCity] = useState(null);
  const [addressState, setAddressState] = useState(null);
  const [addressPostalCode, setAddressPostalCode] = useState(null);
  const [addressCountry, setAddressCountry] = useState(null);
  const [addressFile, setAddressFile] = useState(null);
  const [addressFileType, setAddressFileType] = useState(null);
  const [documentType, setDocumentType] = useState(null);
  const [documentNumber, setDocumentNumber] = useState(null);
  const [documentIssDate, setDocumentIssDate] = useState(null);
  const [documentExpDate, setDocumentExpDate] = useState(null);
  const [documentFile, setDocumentFile] = useState(null);
  const [documentFile2, setDocumentFile2] = useState(null);

  const [documentNumberText, setDocumentNumberText] = useState("ID Number");

  useEffect(() => {
    if (documentType === "dl") {
      setDocumentNumberText("License Number");
    } else if (documentType === "passport") {
      setDocumentNumberText("Passport Number");
    } else if (documentType === "nin") {
      setDocumentNumberText("NIN Number");
    } else {
      setDocumentNumberText("ID Number");
    }
  }, [documentType]);

  async function postDataNormal() {
    const json = { currency: `${currency}` };
    await axios
      .post("users/vbank/request.json", json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);
          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg("An error occurred. Make sure you have an active internet connection.");
        setOpen(true);
      });
  }

  async function postDataMultipart() {
    formData = new FormData();
    formData.append("address_file_type", addressFileType);
    formData.append("address_file", addressFile);
    formData.append("currency", currency);
    formData.append("address_number", addressHouseNumber);
    formData.append("address_street", addressStreet);
    formData.append("address_city", addressCity);
    formData.append("address_state", addressState);
    formData.append("address_postal_code", addressPostalCode);
    formData.append("address_country", addressCountry);
    formData.append("document_type", documentType);
    formData.append("document_number", documentNumber);
    formData.append("document_iss_date", documentIssDate);
    formData.append("document_exp_date", documentExpDate);
    formData.append("document_file", documentFile);
    formData.append("document_file_2", documentFile2);

    await axios
      .post("users/vbank/request.json", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);
          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg("An error occurred.");
        setOpen(true);
      });
  }

  async function requestAccount() {
    if (currency === null) {
      setSeverity("error");
      setErrMsg("Select a currency.");
      setOpen(true);
      return;
    }

    if (currency !== "NGN") {
      if (addressHouseNumber === null || addressHouseNumber.length === 0) {
        setSeverity("error");
        setErrMsg("Enter your address house number");
        setOpen(true);
        return;
      }

      if (addressStreet === null || addressStreet.length < 10) {
        setSeverity("error");
        setErrMsg("Enter your address street.");
        setOpen(true);
        return;
      }

      if (addressCity === null || addressCity.length < 3) {
        setSeverity("error");
        setErrMsg("Enter your address city");
        setOpen(true);
        return;
      }

      if (addressState === null || addressState.length < 3) {
        setSeverity("error");
        setErrMsg("Enter your address state");
        setOpen(true);
        return;
      }

      if (addressPostalCode === null || addressPostalCode.length === 0) {
        setSeverity("error");
        setErrMsg("Enter your address postal code or zip");
        setOpen(true);
        return;
      }

      if (addressCountry === null || addressCountry.length === 0) {
        setSeverity("error");
        setErrMsg("Enter your address country");
        setOpen(true);
        return;
      }

      if (documentType === null || documentType.length === 0) {
        setSeverity("error");
        setErrMsg("Select an ID document type");
        setOpen(true);
        return;
      }

      if (documentNumber === null || documentNumber.length === 0) {
        setSeverity("error");
        setErrMsg("Enter the ID document number as shown on file");
        setOpen(true);
        return;
      }

      if (["passport", "dl"].includes(documentType)) {
        if (documentIssDate === null || documentIssDate.length === 0) {
          setSeverity("error");
          setErrMsg("Enter ID document issue date");
          setOpen(true);
          return;
        }

        if (documentExpDate === null || documentExpDate.length === 0) {
          setSeverity("error");
          setErrMsg("Enter ID document expiry date");
          setOpen(true);
          return;
        }
      }

      if (["nin"].includes(documentType)) {
        if (documentIssDate === null || documentIssDate.length === 0) {
          setSeverity("error");
          setErrMsg("Enter NIN registration date");
          setOpen(true);
          return;
        }
      }

      if (documentFile === null) {
        setSeverity("error");
        setErrMsg("Upload a clear copy of your ID document.");
        setOpen(true);
        return;
      }

      if (["pvc", "dl"].includes(documentType)) {
        if (documentFile2 === null) {
          setSeverity("error");
          setErrMsg("Upload a clear copy of the back of your ID document.");
          setOpen(true);
          return;
        }
      }

      if (addressFileType === null) {
        setSeverity("error");
        setErrMsg("Proof of address file type is required");
        setOpen(true);
        return;
      }

      if (addressFile === null) {
        setSeverity("error");
        setErrMsg("Upload your utility bill or bank statement not more than 3 months old.");
        setOpen(true);
        return;
      }
    }

    setOpenNewBankDialog(false);
    setShowLoading(true);
    if (currency === "NGN") {
      postDataNormal();
    } else {
      postDataMultipart();
    }
  }

  const handleFileInputChange = (event, type) => {
    event.persist();
    const fileTypes = ["pdf", "png", "jpeg", "jpg"];
    const file = event.target.files[0];
    const extension = file.name.split(".").pop().toLowerCase();
    const supported = fileTypes.indexOf(extension) > -1;
    if (!supported) {
      setSeverity("error");
      setErrMsg("Only PDF, JPEG, PNG and JPG files accepted.");
      setOpen(true);
      return;
    }

    if (file) {
      const reader = new FileReader();
      reader.onload = function () {
        if (type === "A") {
          setAddressFile(file);
        } else if (type === "DF") {
          setDocumentFile(file);
        } else {
          setDocumentFile2(file);
        }
      };

      reader.onerror = function (ex) {
        console.log(ex);
      };

      reader.readAsBinaryString(file);
    } else {
      setAddressFile(null);
      event.target.value = null;
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      {companyNotification !== null && showCompanyNotification ? (
        <CompanyNotification
          title={companyNotification.title}
          description={companyNotification.description}
        />
      ) : (
        <> </>
      )}
      <Dialog open={openNewBankDialog}>
        <DialogTitle>
          <MDBox>Bank Account Request - {currency}</MDBox>
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            <MDBox>
              We are required by law to capture your ID and current place of residence. Kindly fill
              out the KYC form below.
            </MDBox>
          </DialogContentText>
          <MDBox sx={{ marginTop: "15px" }}>
            <MDInput
              name="address_number"
              margin="dense"
              label="House Number"
              type="text"
              fullWidth
              variant="outlined"
              onChange={(e) => setAddressHouseNumber(e.target.value)}
            />
            <MDInput
              name="address_street"
              margin="dense"
              label="Street Address"
              type="text"
              fullWidth
              variant="outlined"
              onChange={(e) => setAddressStreet(e.target.value)}
            />
            <MDBox>
              <Grid container spacing={1}>
                <Grid item lg={6} md={6} xs={6}>
                  <MDInput
                    name="address_city"
                    margin="dense"
                    label="City"
                    type="text"
                    fullWidth
                    variant="outlined"
                    onChange={(e) => setAddressCity(e.target.value)}
                  />
                </Grid>
                <Grid item lg={6} md={6} xs={6}>
                  <MDInput
                    name="address_state"
                    margin="dense"
                    label="State"
                    type="text"
                    fullWidth
                    variant="outlined"
                    onChange={(e) => setAddressState(e.target.value)}
                  />
                </Grid>
              </Grid>
            </MDBox>
            <MDBox>
              <Grid container spacing={1}>
                <Grid item lg={6} md={6} xs={6}>
                  <MDInput
                    name="address_postal_code"
                    margin="dense"
                    label="Postal Code / Zip"
                    type="text"
                    fullWidth
                    variant="outlined"
                    onChange={(e) => setAddressPostalCode(e.target.value)}
                  />
                </Grid>
                <Grid item lg={6} md={6} xs={6}>
                  <MDInput
                    inputProps={{ maxLength: 2 }}
                    name="address_country"
                    margin="dense"
                    label="Country (ex. NG, US, UK, DE)"
                    type="text"
                    fullWidth
                    variant="outlined"
                    onChange={(e) => setAddressCountry(e.target.value)}
                  />
                </Grid>
              </Grid>
            </MDBox>
            <MDBox mt={3}>
              <Grid container spacing={1}>
                <Grid item lg={6} md={6} xs={6}>
                  <MDBox mt={1}>
                    <FormControl sx={{ minWidth: 120, width: "100%" }}>
                      <InputLabel>ID Type</InputLabel>
                      <Select
                        label="ID Type"
                        name="document_type"
                        sx={{ padding: "12px", paddingLeft: "3px" }}
                        onChange={(e) => {
                          setDocumentType(e.target.value);
                        }}
                      >
                        <MenuItem value="passport">International Passport</MenuItem>
                        <MenuItem value="dl">Driver&apos;s License</MenuItem>
                        <MenuItem value="nin">National ID (NIN)</MenuItem>
                      </Select>
                    </FormControl>
                  </MDBox>
                </Grid>
                <Grid item lg={6} md={6} xs={6}>
                  <MDInput
                    name="document_number"
                    margin="dense"
                    label={documentNumberText}
                    type="text"
                    fullWidth
                    variant="outlined"
                    onChange={(e) => setDocumentNumber(e.target.value)}
                  />
                </Grid>
              </Grid>
            </MDBox>
            {documentType === "dl" || documentType === "passport" ? (
              <MDBox>
                <Grid container spacing={1}>
                  <Grid item lg={6} md={6} xs={6}>
                    <MDInput
                      type="date"
                      name="document_iss_date"
                      margin="dense"
                      label="Date Issued"
                      fullWidth
                      variant="outlined"
                      onChange={(e) => setDocumentIssDate(e.target.value)}
                    />
                  </Grid>
                  <Grid item lg={6} md={6} xs={6}>
                    <MDInput
                      type="date"
                      name="document_exp_date"
                      margin="dense"
                      label="Expiry Date"
                      fullWidth
                      variant="outlined"
                      onChange={(e) => setDocumentExpDate(e.target.value)}
                    />
                  </Grid>
                </Grid>
              </MDBox>
            ) : (
              <> </>
            )}
            {["nin"].includes(documentType) ? (
              <MDBox>
                <MDInput
                  type="date"
                  name="document_iss_date"
                  margin="dense"
                  label="Registration Date"
                  fullWidth
                  variant="outlined"
                  onChange={(e) => setDocumentIssDate(e.target.value)}
                />
              </MDBox>
            ) : (
              <> </>
            )}
            <MDBox mt={3}>
              <MDTypography variant="caption" pl={1} fontWeight="medium">
                Upload ID Document (PDF, JPEG, PNG)
              </MDTypography>
              <MDInput
                name="document_file"
                margin="dense"
                type="file"
                fullWidth
                variant="outlined"
                onChange={(e) => {
                  handleFileInputChange(e, "DF");
                }}
              />
            </MDBox>
            {documentType === "dl" ? (
              <MDBox mt={1}>
                <MDTypography variant="caption" pl={1} fontWeight="medium">
                  Upload ID Document Back (PDF, JPEG, PNG)
                </MDTypography>
                <MDInput
                  name="document_file_2"
                  margin="dense"
                  type="file"
                  fullWidth
                  variant="outlined"
                  onChange={(e) => {
                    handleFileInputChange(e, "DB");
                  }}
                />
              </MDBox>
            ) : (
              <> </>
            )}
            <MDBox mt={1.5}>
              <MDTypography variant="caption" pl={1} fontWeight="medium" mb={1}>
                Upload Utility Bill / Bank Statement
              </MDTypography>
              <MDBox mt={0.5}>
                <Grid container spacing={1}>
                  <Grid item lg={3} md={3} xs={12}>
                    <MDBox mt={1}>
                      <FormControl sx={{ minWidth: 120, width: "100%" }}>
                        <InputLabel>File Type</InputLabel>
                        <Select
                          label="File type"
                          name="address_file_type"
                          sx={{ padding: "12px", paddingLeft: "3px" }}
                          onChange={(e) => {
                            setAddressFileType(e.target.value);
                          }}
                        >
                          <MenuItem value="utilityBill">Utility Bill</MenuItem>
                          <MenuItem value="bankStatement">Bank Statement</MenuItem>
                        </Select>
                      </FormControl>
                    </MDBox>
                  </Grid>
                  <Grid item lg={9} md={9} xs={12}>
                    <MDInput
                      name="utility_bill"
                      margin="dense"
                      type="file"
                      fullWidth
                      variant="outlined"
                      onChange={(e) => {
                        handleFileInputChange(e, "A");
                      }}
                    />
                  </Grid>
                </Grid>
              </MDBox>
              <MDBox>
                <MDTypography variant="caption" color="warning" pl={1} mt={-1} fontWeight="medium">
                  Note! Document should be within 3 months.
                </MDTypography>
              </MDBox>
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenNewBankDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="success"
            variant="outlined"
            onClick={() => {
              requestAccount();
            }}
          >
            Proceed
          </MDButton>
        </DialogActions>
      </Dialog>
      <Dialog open={openVBankDialog} fullWidth="xs">
        <DialogTitle>
          <MDBox>Bank Account Request</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox sx={{ marginTop: "15px" }}>
            <MDBox mt={1}>
              <MDBox>
                <FormControl sx={{ minWidth: 120, width: "100%" }}>
                  <InputLabel>Select Currency</InputLabel>
                  <Select
                    label="Select Currency"
                    onChange={(e) => {
                      setCurrency(e.target.value);
                    }}
                    sx={{ padding: "12px", paddingLeft: "3px" }}
                  >
                    {
                      // --> Notice below changes
                      currencies.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                        currencies.map((record) => {
                          if (record.vbank_enabled) {
                            return (
                              <MenuItem value={record.currency_code}>
                                {record.currency_code}
                              </MenuItem>
                            );
                          }
                          return null;
                        })
                    }
                  </Select>
                </FormControl>
              </MDBox>
              {currency != null && commercials != null ? (
                <MDBox mt={3}>
                  {currency === "NGN" ? (
                    <Alert severity="info">{currency} bank accounts are free forever!</Alert>
                  ) : (
                    <Alert severity="info">
                      <ul>
                        <li>
                          You will be charged{" "}
                          <b>
                            {currency} {(commercials[currency].fee / 100).toFixed(2)}
                          </b>{" "}
                          account opening fee.
                        </li>
                        {commercials[currency].renewal ? (
                          <li>
                            A monthly renewal fee of{" "}
                            <b>
                              {currency} {(commercials[currency].renewal / 100).toFixed(2)}
                            </b>{" "}
                            is required to maintain your account.
                          </li>
                        ) : (
                          <> </>
                        )}
                      </ul>
                    </Alert>
                  )}
                </MDBox>
              ) : (
                <> </>
              )}
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenVBankDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="success"
            variant="outlined"
            onClick={() => {
              setOpenVBankDialog(false);
              if (["USD", "EUR", "GBP"].includes(currency)) {
                setOpenNewBankDialog(true);
              } else {
                requestAccount();
              }
            }}
          >
            Proceed
          </MDButton>
        </DialogActions>
      </Dialog>
      <MDBox pt={1} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={12} lg={12}>
                <Card sx={{ width: "100%", marginTop: "-5px" }}>
                  <MDBox
                    pt={2}
                    px={2}
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    <MDTypography variant="h6" fontWeight="medium">
                      My Bank Accounts
                    </MDTypography>
                    <MDButton
                      variant="contained"
                      color="dark"
                      onClick={() => {
                        // if (currency !== "NGN") {
                        //   setOpenNewBankDialog(true);
                        // } else {
                        //   requestAccount();
                        // }
                        setCurrency(null);
                        setOpenVBankDialog(true);
                      }}
                    >
                      <Icon sx={{ fontWeight: "bold" }}>add</Icon>
                      &nbsp;request account
                    </MDButton>
                  </MDBox>
                  {virtualAccounts <= 0 ? (
                    <MDBox pt={3} pb={2} px={2}>
                      <MDBox
                        component="ul"
                        display="flex"
                        flexDirection="column"
                        p={0}
                        m={0}
                        sx={{ listStyle: "none" }}
                      >
                        <small>No bank accounts found.</small>
                      </MDBox>
                    </MDBox>
                  ) : (
                    <MDBox pt={3} pb={2}>
                      <MDBox display="flex" flexDirection="column" p={0} m={0}>
                        {virtualAccounts.map((record, index) => (
                          <MDBox
                            idx={index}
                            borderRadius="lg"
                            sx={{
                              marginLeft: "10px",
                              marginTop: "5px",
                              marginRight: "10px",
                              marginBottom: "15px",
                              border: ({ borders: { borderWidth, borderColor } }) =>
                                `${borderWidth[1]} solid ${borderColor}`,
                            }}
                          >
                            <Grid container spacing={0} xs={12} lg={12} md={12}>
                              <Grid item xs={12} lg={4} md={4}>
                                <MDBox p={3}>
                                  <MDBox mb={1.5} lineHeight={0}>
                                    <MDTypography variant="caption" color="text">
                                      Currency:
                                    </MDTypography>
                                  </MDBox>
                                  <MDBox mb={1} lineHeight={0}>
                                    <MDTypography
                                      variant="caption"
                                      fontWeight="medium"
                                      textTransform="capitalize"
                                    >
                                      {record.currency}
                                    </MDTypography>
                                  </MDBox>
                                </MDBox>
                              </Grid>
                              {Object.keys(record.details).map((key) => (
                                <Grid item xs={12} lg={4} md={4}>
                                  <MDBox p={3} mr={3}>
                                    <MDBox mb={0.5} lineHeight={0}>
                                      <MDTypography variant="caption" color="text">
                                        {key}:&nbsp;&nbsp;&nbsp;
                                      </MDTypography>
                                    </MDBox>
                                    <MDBox
                                      mb={1}
                                      lineHeight={0}
                                      display="flex"
                                      justifyContent="space-between"
                                      alignItems="center"
                                    >
                                      <MDTypography
                                        variant="caption"
                                        fontWeight="medium"
                                        textTransform="capitalize"
                                      >
                                        {record.details[key]}
                                      </MDTypography>
                                      <MDTypography>
                                        <Icon
                                          onClick={() => {
                                            navigator.clipboard.writeText(record.details[key]);
                                            const wrd =
                                              key[0].toUpperCase() + key.slice(1).toLowerCase();
                                            setSeverity("success");
                                            setErrMsg(`${wrd} copied!`);
                                            setOpen(true);
                                          }}
                                        >
                                          copy
                                        </Icon>
                                      </MDTypography>
                                    </MDBox>
                                  </MDBox>
                                </Grid>
                              ))}
                            </Grid>
                            <Grid item xs={12} sx={{ mt: 3, p: -3 }}>
                              <Alert severity="info" sx={{ "& a": { fontWeight: 600 } }}>
                                - This account can only receive <b>{record.currency}</b>. Sending
                                any other currency will result in loss of funds.
                                <br />- A <b>1.4%</b> transaction fee is charged on funds received
                                to this account.
                                <br />- Your funds are secure and protected by local and
                                international banking regulations and standards.
                              </Alert>
                            </Grid>
                          </MDBox>
                        ))}
                      </MDBox>
                    </MDBox>
                  )}
                </Card>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default BankAccounts;
